<template>
    <div>
        <v-dialog v-model="is_loading" persistent width="400">
            <v-card color="primary" dark>
                <v-card-text>
                    しばらくお待ちください......
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            is_loading: {
                type: Boolean,
                require: false,
                'default': false
            }
        }

    }
</script>
